import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import photoFrame from '../assets/images/PhotoFrame(1).png';
import './Selfie.css';
import toast from 'react-hot-toast';
import Profile from './Profile';
import ProfileService from '../services/Profile';
import { serverAssets } from "../constants/common"
import ScratchReward from '../component/ScratchReward';

const Selfie = () => {
    const navigate = useNavigate();
    let personalInfoResponse = useSelector(state => state.userTypeSlice.personalInfoResponse);
    
    const [cameraActive, setCameraActive] = useState(false);
    const [capturedImage, setCapturedImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const fileInputRef = useRef(null);
        // Handle file upload from device
        const handleFileChange = (event) => {
            const file = event.target.files[0];
            if (file && file.type.startsWith('image/')) {
                setCapturedImage(file);
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreview(reader.result);
                };
                reader.readAsDataURL(file);
                toast.success('Image selected from device!');
            } else {
                toast.error('Please select a valid image file.');
            }
        };
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const streamRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [scratchCardDetails, setScratchCardDetails] = useState(null);

    const formatDateTime = (date) => {
        if (!date) return '';
            return new Date(date).toLocaleString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
        });
    };

    const startCamera = async () => {
        try {
            setLoading(true);
            
            // Check browser support
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                toast.error('Camera not supported on this browser');
                setLoading(false);
                return;
            }

            // Simpler constraints for better browser compatibility
            const constraints = {
                video: {
                    facingMode: 'user'
                },
                audio: false
            };

            const stream = await navigator.mediaDevices.getUserMedia(constraints);
            
            // First set the active state
            setCameraActive(true);
            
            // Then set the stream after state update
            setTimeout(() => {
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    streamRef.current = stream;
                    
                    // Play video
                    videoRef.current.play().catch(err => {
                        console.error('Play error:');
                        toast.error('Failed to start video playback');
                    });
                    
                    toast.success('Camera opened successfully');
                }
            }, 50);
        } catch (error) {
            console.error('Camera error:');
            setCameraActive(false);
            
            if (error.name === 'NotAllowedError') {
                toast.error('Camera permission denied. Please allow access in browser settings.');
            } else if (error.name === 'NotFoundError') {
                toast.error('No camera device found');
            } else if (error.name === 'NotReadableError') {
                toast.error('Camera is already in use by another application');
            } else {
                toast.error(`Unable to access camera: ${error.message}`);
            }
        } finally {
            setLoading(false);
        }
    };

    const stopCamera = () => {
        if (streamRef.current) {
            streamRef.current.getTracks().forEach(track => track.stop());
            setCameraActive(false);
        }
    };

    const capturePhoto = () => {
        if (videoRef.current && canvasRef.current) {
            const video = videoRef.current;
            const canvas = canvasRef.current;
            const context = canvas.getContext('2d');
            
            // Set canvas dimensions to match video
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            
            // Mirror the image for selfie (flip horizontally)
            context.scale(-1, 1);
            context.drawImage(video, -canvas.width, 0);
            
            // Convert canvas to blob and create preview
            canvas.toBlob((blob) => {
                if (blob) {
                    setCapturedImage(blob);
                    setPreview(canvas.toDataURL('image/jpeg'));
                    stopCamera();
                    toast.success('Photo captured successfully!');
                }
            }, 'image/jpeg', 0.95);
        }
    };

    const handleUpload = async () => {
        if (!capturedImage) {
            toast.error('Please capture a photo first');
            return;
        }
        
        setLoading(true);
        const formData = new FormData();
        // formData.append('file', capturedImage, 'selfie.jpg');
        formData.append('contact_id', personalInfoResponse.response.message.contact_id);
        formData.append('selfie_id', personalInfoResponse.response.message.selfie_icon[0].id);
        formData.append('selfie_image', capturedImage);
        
        

        
        try {
            const token = localStorage.getItem('access_token');
            const response = await ProfileService.uploadSelfie(formData, token);

            if (response.statusCode === 200) {
                toast.success('Selfie uploaded successfully!');
                setTimeout(() => {
                    navigate('/landing');
                }, 200);
                setCapturedImage(null);
                setPreview(null);
            } else {
                toast.error('Failed to upload selfie');
            }
        } catch (error) {
            console.error('Upload error:');
            toast.error('Error uploading selfie');
        } finally {
            setLoading(false);
        }
    };

    const handleRetake = () => {
        setCapturedImage(null);
        setPreview(null);
        startCamera();
    };

    useEffect(() => {
        if (!personalInfoResponse?.response?.message?.selfie_icon || personalInfoResponse?.response?.message?.selfie_icon.length === 0) {
            toast.error('Selfie feature is not available for your account');
            navigate('/landing');
        }
    }, [personalInfoResponse, navigate]);

    useEffect(() => {
        return () => {
            if (streamRef.current) {
                streamRef.current.getTracks().forEach(track => track.stop());
            }
        };
    }, []);

    useEffect(() => {
        const fetchCardDeatails = async () => {
            try {
                const selfieId = personalInfoResponse?.response?.message?.selfie_icon[0]?.ad_selfie_config_id;
                const res = await ProfileService.fetchScratchCardDeatails(selfieId);
                if(res.success == true) {
                    setScratchCardDetails(res.response);
                    setLoading(false);
                } else {
                    toast.error('Failed to fetch scratch card details');
                    setScratchCardDetails(null);
                    setLoading(false);
                }
            } catch (error) {
                console.error('Error fetching card details:');
                 setScratchCardDetails(null);
                 setLoading(false);
            }
        }
        fetchCardDeatails();
    }, [])

    let imgUrl = personalInfoResponse?.response?.message?.selfie_icon[0]?.image_url;
    const statusElement = personalInfoResponse?.response?.message?.selfie_icon[0]?.status;
        // statusElement: 1 = approved, 2 = rejected

    

    return (
        <div className="selfie-page">
            <div className="background-decoration">
                <div className="decoration-blob blob-1"></div>
                <div className="decoration-blob blob-2"></div>
                <div className="decoration-blob blob-3"></div>
            </div>
            
            {!imgUrl && 
            <Container className="selfie-container">
                <Row className="align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
                    <Col lg={8} md={10} sm={12} className="text-center">
                        <div className="selfie-card">
                            <h1 className="selfie-title">Capture Your Moment</h1>
                            <p className="selfie-subtitle">
                                {cameraActive ? 'Position yourself and click capture' : 'Click start to open camera'}
                            </p>
                            
                            <div className="image-wrapper" style={{display: "block"}}>
                                <canvas ref={canvasRef} style={{ display: 'none' }} />
                                
                                {cameraActive && (
                                    <div className="camera-container">
                                        <video
                                            key="video-stream"
                                            ref={videoRef}
                                            autoPlay={true}
                                            playsInline={true}
                                            muted={true}
                                            className="video-feed"
                                        />
                                        <div className="camera-frame"></div>
                                    </div>
                                )}
                                
                                {!cameraActive && preview && (
                                    <>
                                        <img 
                                            src={preview} 
                                            alt="Captured Selfie" 
                                            className="selfie-image captured"
                                        />
                                        <div style={{ marginTop: '1rem' }}>
                                            <label htmlFor="upload-selfie-input" style={{ cursor: 'pointer', color: '#005baa', fontWeight: 500 }}>
                                                <span role="img" aria-label="upload">⬆️</span> Upload image from device
                                            </label>
                                            <input
                                                id="upload-selfie-input"
                                                type="file"
                                                accept="image/*"
                                                style={{ display: 'none' }}
                                                ref={fileInputRef}
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                    </>
                                )}

                                {!cameraActive && !preview && (
                                    <>
                                        <div className="photo-frame-container" onClick={startCamera}>
                                            <img 
                                                src={photoFrame} 
                                                alt="Selfie PhotoFrame" 
                                                className="selfie-image"
                                            />
                                            <div className="click-overlay">
                                                <span className="click-text">📷 Click to Start Camera</span>
                                            </div>
                                        </div>
                                        <div style={{ marginTop: '1rem' }}>
                                            <label htmlFor="upload-selfie-input" style={{ cursor: 'pointer', color: '#005baa', fontWeight: 500 }}>
                                                <span role="img" aria-label="upload">⬆️</span> Upload image from device
                                            </label>
                                            <input
                                                id="upload-selfie-input"
                                                type="file"
                                                accept="image/*"
                                                style={{ display: 'none' }}
                                                ref={fileInputRef}
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className="camera-actions">
                                {cameraActive && (
                                    <>
                                        <button 
                                            className="btn btn-capture"
                                            onClick={capturePhoto}
                                        >
                                            📸 Capture Photo
                                        </button>
                                        <button 
                                            className="btn btn-cancel"
                                            onClick={stopCamera}
                                        >
                                            ✕ Cancel
                                        </button>
                                    </>
                                )}
                                
                                {preview && (
                                    <>
                                        <button 
                                            className="btn btn-upload"
                                            onClick={handleUpload}
                                            disabled={loading}
                                        >
                                            {loading ? 'Uploading...' : '✓ Upload Selfie'}
                                        </button>
                                        <button 
                                            className="btn btn-retake"
                                            onClick={handleRetake}
                                            disabled={loading}
                                        >
                                            ↻ Retake
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>}

            {imgUrl && (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '80vh',
                    width: '100%',
                }}>
                    <div className="selfie-card" style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        background: '#fff',
                        padding: '2rem 1.5rem',
                        borderRadius: '20px',
                        boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
                        maxWidth: '400px',
                        width: '100%',
                    }}>
                        <h1 className="selfie-title" style={{marginBottom: '1rem', textAlign: 'center'}}>Selfie kheecho, inam jeeto</h1>
                        <div style={{
                            position: 'relative',
                            display: 'inline-block',
                            padding: '6px',
                            borderRadius: '22px',
                            background: 'linear-gradient(135deg, #005baa 0%, #00b8d9 40%, #6f42c1 100%)',
                            boxShadow: '0 6px 32px rgba(0,91,170,0.13)',
                            margin: '0 auto 1.5rem auto',
                        }}>
                            {(statusElement === 1 || statusElement === 2) && (
                                <span
                                    style={{
                                        position: 'absolute',
                                        top: '10px',
                                        right: (statusElement === 1 || statusElement === 2) ? '10px' : '60px',
                                        zIndex: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                    }}
                                   title={
                                        statusElement === 1
                                            ? 'Approved'
                                            : statusElement === 2
                                            ? 'Rejected'
                                            : 'Pending'
                                    } 
                                >
                                    {statusElement === 1 ? (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" >
                                                <circle cx="11" cy="11" r="11" fill="#28a745"/>
                                                <path d="M6 12.5L10 16L16 8" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            <span style={{ color: '#28a745', fontWeight: 'bold', marginLeft: '6px', fontSize: '0.95rem' }}>Approved</span>
                                        </div>
                                    ) :  (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="11" cy="11" r="11" fill="#dc3545"/>
                                                <path d="M7 7L15 15M15 7L7 15" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"/>
                                            </svg>
                                            <span style={{ color: '#dc3545', fontWeight: 'bold', marginLeft: '6px', fontSize: '0.95rem' }}>Rejected</span>
                                        </div>
                                        
                                    )
                                    // : (
                                    //     <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    //         <circle cx="11" cy="11" r="11" fill="#ffc107"/>
                                    //         <path d="M11 6V12" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"/>
                                    //         <circle cx="11" cy="15" r="1.2" fill="#fff"/>
                                    //     </svg>
                                    // )
                                    }
                                </span>
                            )}
                            <img 
                                src={imgUrl}
                                alt="Selfie" 
                                className='img-fluid'
                                style={{
                                    maxWidth: '338px',
                                    width: '100%',
                                    height: 'auto',
                                    borderRadius: '16px',
                                    border: '4px solid #fff',
                                    display: 'block',
                                    boxShadow: '0 2px 12px rgba(0,0,0,0.10)'
                                }}
                            />
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <div style={{fontSize: '1.1rem', color: '#444', marginBottom: '0.5rem'}}>
                                {personalInfoResponse?.response?.message?.selfie_icon[0]?.description || 'No description available.'}
                            </div>
                            <div style={{ fontSize: '0.95rem', color: '#888' }}>
                            <div style={{ fontSize: '0.95rem', color: '#888' }}>
                            <div>
                                Active from: {formatDateTime(personalInfoResponse?.response?.message?.selfie_icon[0]?.valid_from)}
                            </div>
                            <div>
                                Expires on: {formatDateTime(personalInfoResponse?.response?.message?.selfie_icon[0]?.valid_to)}
                            </div>
                        </div>
                        </div>
                        </div>
                        {!loading && <ScratchReward 
                        imgUrl={imgUrl}
                        rewardText={scratchCardDetails?.scratchMsg}
                        // rewardText={"Congratulations! You've won a reward."}
                        isScratchable={scratchCardDetails?.isScractable}
                        // isScratchable={true}
                        gift_name={scratchCardDetails?.data[0]?.gift_name}
                        selfieId={personalInfoResponse?.response?.message?.selfie_icon[0]?.ad_selfie_config_id}
                        />}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Selfie;
